import { useTranslation } from 'react-i18next'

import { Input } from '#/shared/ui/input'

interface CampaignCustomDaysInputProps {
  value: string
  onChange: (days: string) => void
  invalid: boolean
}

/** The day count behind a "Custom" wait chip — disclosed beside it once picked. */
export function CampaignCustomDaysInput({
  value,
  onChange,
  invalid,
}: CampaignCustomDaysInputProps) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-1.5">
      <div className="w-20">
        <Input
          autoFocus
          inputSize="sm"
          type="number"
          inputMode="numeric"
          min={1}
          max={365}
          value={value}
          error={invalid}
          onChange={(event) => onChange(event.target.value)}
          placeholder={t('campaigns.sequence.addStep.customDaysPlaceholder')}
          aria-label={t('campaigns.sequence.addStep.customDaysAria')}
          className="input-mobile-safe"
        />
      </div>
      <span className="text-xs text-warm-500">
        {t('campaigns.sequence.addStep.customDaysUnit')}
      </span>
    </div>
  )
}
